import React, { createContext, useReducer } from 'react';

const initialState = {
  showChat: false,
};

export const LiveChatContext = createContext(initialState);

export const LiveChatContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'update':
        return {
          ...state,
          showChat: action.payload,
        };
      default:
        return {
          ...state,
        };
    }
  }, initialState);

  return (
    <LiveChatContext.Provider value={{ state, dispatch }}>
      {children}
    </LiveChatContext.Provider>
  );
};
